<svelte:options tag={null} />

<script lang="ts">
  export let id: string;
  export let placeholder: string;
  export let isvalid: boolean;
  export let isinvalid: boolean;
  export let disabled = false;
  export let required = false;
  export let isvisible = false;

  function setType(isvisible: boolean) {
    return isvisible ? 'text' : 'password';
  }

  function onClick(): void {
    isvisible = !isvisible;
  }

  function setButtonLabel(isvisible: boolean) {
    return isvisible ? 'Hide' : 'Show';
  }
</script>

<div class="mc-password-input" {...$$restProps}>
  <input
    type={setType(isvisible)}
    class="mc-text-input mc-password-input__control"
    class:is-valid={isvalid}
    class:is-invalid={isinvalid}
    aria-invalid={isinvalid}
    spellcheck="false"
    {id}
    {placeholder}
    {disabled}
    {required}
  />

  <button
    type="button"
    class="mc-password-input__button"
    role="switch"
    aria-checked={isvisible ? 'true' : 'false'}
    aria-pressed={isvisible ? 'true' : 'false'}
    on:click={onClick}
  >
    {setButtonLabel(isvisible)}
  </button>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.text-input';
  @import '@mozaic-ds/styles/components/c.password-input';
</style>
